import siteRouteData from './siteRoutes.json';

export const SITE_ORIGIN: string = siteRouteData.siteOrigin;
export const MARKETING_PATHS: readonly string[] = siteRouteData.marketingPaths;
export const APP_PATHS: readonly string[] = siteRouteData.appPaths;
export const EXACT_REDIRECTS: Readonly<Record<string, string>> = siteRouteData.exactRedirects;
export const TRACKING_QUERY_KEYS: readonly string[] = siteRouteData.trackingQueryKeys;

const marketingSet = new Set(MARKETING_PATHS);
const appSet = new Set(APP_PATHS);

export function normalizePath(pathname: string): string {
  if (!pathname) return '/';
  const noQuery = pathname.split('?')[0] || '/';
  const trimmed = noQuery.replace(/\/+$/, '');
  return trimmed || '/';
}

export function isMarketingPath(pathname: string): boolean {
  return marketingSet.has(normalizePath(pathname));
}

export function isAppPath(pathname: string): boolean {
  return appSet.has(normalizePath(pathname));
}

export function isKnownPath(pathname: string): boolean {
  return isMarketingPath(pathname) || isAppPath(pathname);
}

export function getExactRedirect(pathname: string): string | undefined {
  return EXACT_REDIRECTS[normalizePath(pathname)];
}

export function canonicalUrlForPath(pathname: string): string {
  const normalized = normalizePath(pathname);
  return normalized === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${normalized}`;
}
